/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaskCategory } from '../../models/task-category';
import { TaskStatus } from '../../models/task-status';
import { UpdateTaskCommandResult } from '../../models/update-task-command-result';

export interface ApiTaskUpdateTaskPut$Params {
      body?: {
'Id'?: string;
'Subject'?: string;
'Description'?: string;
'StakeholderId'?: number;
'EndDate'?: string;
'AdditionalDetails'?: string;
'TaskCategory': TaskCategory;
'Attachments'?: Array<Blob>;
'CopyToList'?: Array<string>;
'ResponsibleIds'?: Array<string>;
'Status': TaskStatus;
}
}

export function apiTaskUpdateTaskPut(http: HttpClient, rootUrl: string, params?: ApiTaskUpdateTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskUpdateTaskPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateTaskCommandResult>;
    })
  );
}

apiTaskUpdateTaskPut.PATH = '/api/Task/UpdateTask';
